import 'core-js';
import 'core-js/proposals/promise-with-resolvers'; // Latest version of pdfjs uses this
import 'regenerator-runtime/runtime';
import ReactDOM from 'react-dom';
import Dashboard from 'dashboard/ConnectedApplication';
import '@formatjs/intl-listformat/polyfill';
import 'dashboard/styles/fonts.css';

document.getElementById('main-application');

ReactDOM.render(<Dashboard />, document.getElementById('main-application'));
